"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./get/index.js");exports.useGetImageHealthService=e,exports.default=t=>e(t);
//# sourceMappingURL=index.js.map
